import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';

export const getWidgetSettingsLink = (projectKey: string) =>
	`/jira/servicedesk/projects/${projectKey}/settings/widget`;
export const getNextGenWidgetSettingsLink = (hostname: string, projectKey: string) =>
	`https://${hostname}${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, projectKey)}/widget`;
